import * as angular from "angular";
import { countriesConstants } from "../utils/constants/countries.constants";

export class CountryDataProvider {
    public countries = [...countriesConstants.countries];

    getCountries(): object[] {
        return this.countries;
    }

    getCountryFromCode(country: any): object | null {
        let selectedCountry = null;
        angular.forEach(this.countries, (countryObj: any) => {
            if (countryObj.code == country) {
                selectedCountry = countryObj;
            }
        });
        return selectedCountry;
    }

    searchCountries(query: string): object[] {
        return query && query != ""
            ? this.countries.filter((obj: object) => {
                  return (
                      obj["dial_code"] &&
                      (obj["name"].toLowerCase().indexOf(query.toLowerCase()) !=
                          -1 ||
                          obj["dial_code"].indexOf(query) != -1)
                  );
              })
            : this.countries;
    }
}

angular
    .module("vcDataProvider")
    .service("CountryDataProvider", CountryDataProvider);
